var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bhelp"},[_c('div',{staticClass:"content"},_vm._l((_vm.resource),function(cell){return _c('van-cell',{key:cell.id,attrs:{"title":cell.title,"is-link":"","to":("/recommend/" + (cell.id))}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }